export default function animatePromoBlock() {
	const promoBlock = document.querySelector('.promo');

	if (!promoBlock) return;

	promoBlock.addEventListener('click', (e) => {
		if (e.currentTarget.classList.contains('opened')) {
			const promoDownloads = promoBlock.querySelector('.promo__downloads');
			if (promoDownloads && promoDownloads.contains(e.target)) return;

			e.currentTarget.classList.remove('opened');
		} else {
			const promoLinks = promoBlock.querySelector('.promo__links');
			if (promoLinks && promoLinks.contains(e.target)) return;

			e.currentTarget.classList.add('opened');
			setTimeout(() => {
				window.scrollTo({
					top: document.body.scrollHeight,
					behavior: 'smooth'
				});
			}, 500);
		}
	});
}
